// extracted by css-extract-rspack-plugin
var _1 = "f6Rb8";
var _2 = "QkerH";
var _3 = "jFHYY";
var _4 = "gR7_v";
var _5 = "qUrge";
export { _1 as "swipeContainer", _2 as "swipeIcon", _3 as "swipeIconFull", _4 as "swipeLeft", _5 as "swipeRight" }
